import React from 'react';
import Benefit from '../Benefit';
import BenefitPlaceholder from '../BenefitPlaceholder';
import s from './Benefits.scss';
var Benefits = function (_a) {
    var benefits = _a.benefits, showPlaceholder = _a.showPlaceholder;
    return (React.createElement("div", { className: s['root'] },
        benefits.map(function (benefit, index) { return (React.createElement(Benefit, { key: index, benefit: benefit, className: s['benefit'] })); }),
        showPlaceholder && benefits.length === 0 && React.createElement(BenefitPlaceholder, null)));
};
Benefits.displayName = 'Benefits';
export default Benefits;
//# sourceMappingURL=Benefits.js.map